// 004: the parent data store bound to the context ProfileClient (research R7).
import { useMemo, useSyncExternalStore } from "react";

import {
  type ParentData,
  parentData,
  type ParentDataStore,
} from "./parentDataStore";
import { type ProfileClient, useProfileClient } from "./profileApi";

export type ParentActions = {
  [
    K in Exclude<keyof ParentDataStore, "getSnapshot" | "subscribe" | "clear">
  ]: ParentDataStore[K] extends (c: ProfileClient, ...rest: infer A) => infer R
    ? (...rest: A) => R
    : never;
};

/** The store's state plus its operations bound to the context's ProfileClient. */
export function useParentData(): ParentData & { actions: ParentActions } {
  const client = useProfileClient();
  const state = useSyncExternalStore(
    parentData.subscribe,
    parentData.getSnapshot,
    parentData.getSnapshot,
  );
  const actions = useMemo<ParentActions>(
    () => ({
      refresh: () => parentData.refresh(client),
      refreshStudents: () => parentData.refreshStudents(client),
      updateProfile: (b) => parentData.updateProfile(client, b),
      addStudent: (b, k) => parentData.addStudent(client, b, k),
      updateStudent: (id, b) => parentData.updateStudent(client, id, b),
      removeStudent: (id) => parentData.removeStudent(client, id),
      addAddress: (b, k) => parentData.addAddress(client, b, k),
      updateAddress: (id, b) => parentData.updateAddress(client, id, b),
      deleteAddress: (id) => parentData.deleteAddress(client, id),
      setDefaultAddress: (id) => parentData.setDefaultAddress(client, id),
    }),
    [client],
  );
  return { ...state, actions };
}
